var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e{fill:#fff;}.a{stroke:#707070;}.b{clip-path:url(#a);}.c,.f{fill:#fece27;}.c{opacity:0.198;}.d{fill:#1f0256;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 240,
    height: 240,
    transform: "translate(538 206)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-538 -206)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(538 206)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 120,
    cy: 120,
    r: 120,
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.135 63.95)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.117)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2920.653,645.577v31.06l26.9,15.53v-31.06Z",
    transform: "translate(-2920.653 -630.047)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2920.653,642.833l26.9-15.53,26.9,15.53-26.9,15.53Z",
    transform: "translate(-2920.653 -627.302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2952.3,661.107l26.9-15.53v31.06l-26.9,15.53Z",
    transform: "translate(-2925.406 -630.047)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.325 23.795)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2872.654,673.577v31.06l26.9,15.53v-31.06Z",
    transform: "translate(-2872.654 -658.046)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2872.654,670.833l26.9-15.53,26.9,15.53-26.9,15.53Z",
    transform: "translate(-2872.654 -655.302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2904.305,689.107l26.9-15.53v31.06l-26.9,15.53Z",
    transform: "translate(-2877.406 -658.046)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 49.147)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2824.027,703.407v31.06l26.9,15.53v-31.06Z",
    transform: "translate(-2824.027 -687.877)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2824.027,700.663l26.9-15.53,26.9,15.53-26.9,15.53Z",
    transform: "translate(-2824.027 -685.133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M2855.678,718.937l26.9-15.53v31.06l-26.9,15.53Z",
    transform: "translate(-2828.779 -687.877)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.513604c85c42920fbdb79a45e17120c5.svg";
export { ForwardRef as ReactComponent };